import { inject } from "mobx-react";

import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import type { PreviousNextItemFragment } from "@ihr-radioedit/inferno-webapi";
import { placeholderImage } from "../../../../core/lib/image";
import { formatImage } from "../../../../core/lib/image-asset";
import MagicLink from "../../../../core/ui/MagicLink.component";
import { CoastFeedItemType, getCoastFeedImg } from "../../lib/coastFeed";
import { RESPONSIVE_IMAGE } from "../../shared/constants";
import { Store } from "../../../../../client/stores";

interface CoastPreviousNextItemProps {
    item: PreviousNextItemFragment;
    type: "previous" | "next";
    basePath: string | null;
    store?: Store;
}

export const CoastPreviousNextItem = inject("store")(({ item, type, basePath, store }: CoastPreviousNextItemProps) => {
    if (!store) {
        return null;
    }

    const { summary } = item;

    const thumb = formatImage(summary.image || placeholderImage, store.env);
    const { imgSrc, srcset } = getCoastFeedImg(thumb, CoastFeedItemType.SHOW, { quality: 80 });
    const itemUrl = basePath ? `${basePath}/${item.slug || ""}` : "#";

    return (
        <div className={`component-coast-previous-next-item ${type}`}>
            <MagicLink to={itemUrl} context={item.slug || undefined}>
                <figure className="item-thumb">
                    <ResponsiveImage
                        alt={summary.title}
                        src={imgSrc}
                        srcset={srcset}
                        initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
                        initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
                    />

                    <figcaption>{item.summary.title}</figcaption>
                </figure>
            </MagicLink>

            <MagicLink className="more-link" to={itemUrl} context={item.slug || undefined}>
                {type === "next" ? `${type} >>` : `<< ${type}`}
            </MagicLink>
        </div>
    );
});
